<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <scratch-card-report-table></scratch-card-report-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import ScratchCardReportTable from './ScratchCardReportTable.vue'

  export default {
    name: 'scratchcard-report',
    components: {ScratchCardReportTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/report/mini-games/scratchcard/ScratchCardReport.vue